module.exports = __webpack_public_path__ + "img/arrow-right-arrow-left.3ca16060.svg";